export default __webpack_public_path__ + "static/media/america_flag.53ccb1bb.png";